<template>
	<div
		:class="[
			'menu-button',
			variantName ? 'menu-button--' + variantName : '',
			dispatchDropUp ? 'is-upward' : ''
		]"
		:id="`${uid}`"
		ref="dropdownPosRef"
	>
		<!-- DEV: Spinner Button component should be added here when necessary.-->
		<Spinner
			class="btn-spinner-overlay"
			v-if="isLoading"
			:processor="{ loading: true }"
			:variant="'buttons'"
			data-test="spinner"
		/>
		<Button
			:class="[
				'btn btn--has-icon',
				variantName ? 'btn--' + variantName : ''
			]"
			:btnClick="toggleList"
			:disabled="disabled"
			:iconClassName="'icon-caret_down'"
			:iconBeforeLabel="false"
			:labelText="value.text"
		>
		</Button>

		<DropdownList
			ref="dropdownListRef"
			:id="`${uid}_ddl`"
			:isOpen="isOpen"
			:options="items"
			:value="value.value"
			@change="changeSelectedItem"
		/>
		<PopperPosition
			trackedRefName="dropdownPosRef"
			popoverRefName="dropdownListRef"
			placement="bottom-start"
			:popperVisible="isOpen"
			strategy="fixed"
			@popperMinWidthChanged="setpopperMinWidth"
			@positionUpdated="updateIconOrientation"
			ref="popperPosition"
		/>
	</div>
</template>

<script>
import DropdownList from '@/components/forms/dropdown/dropdown-list';
import DocumentClickedMixin from '@/mixins/document-click';
import Button from '@/components/forms/button/button';
import Spinner from '@/components/visual/spinner/spinner';
import PopperPosition from '@/components/visual/popper-position';

// mixins
import popperPositionMixin from '@/mixins/popper-position-mixin';

export default {
	name: 'menuButton',
	mixins: [DocumentClickedMixin('closeHandler'), popperPositionMixin],
	inheritAttrs: false,
	components: {
		DropdownList,
		Button,
		Spinner,
		PopperPosition
	},
	model: {
		event: 'change'
	},
	props: {
		variantName: {
			type: String,
			default: ''
		},
		items: {
			type: Array,
			required: true
		},
		pendingChanges: {
			type: Boolean,
			default: true
		},
		value: {
			type: Object,
			required: true
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dispatchDropUp: null,
			isOpen: false
		};
	},
	mounted() {
		document.addEventListener('scroll', this.changeScrollPosition);
		this.changeScrollPosition();
	},
	beforeDestroy() {
		document.removeEventListener('scroll', this.changeScrollPosition);
	},
	methods: {
		changeSelectedItem(value) {
			this.isOpen = false;
			const item = this.items.find(op => op.value === value);
			this.$emit('change', item);
		},
		changeScrollPosition() {
			this.dispatchDropUp =
				window.innerHeight -
					this.$refs.dropdownPosRef.getBoundingClientRect().top <
				100;
		},
		closeHandler() {
			this.isOpen = false;
		},
		toggleList() {
			if (!this.isLoading) {
				this.isOpen = !this.isOpen;
			} else {
				this.isOpen = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Menu Button Styles
    * Can use SCSS variables = TRUE
*/

@import '@/scss/5-objects/_form.scss';

.menu-button {
	display: inline-flex;
	position: relative;

	&.is-upward {
		.icon-caret_down {
			transform: rotate(180deg);
		}
	}
}

/*------------------------------------*
#MENU BUTTON SPINNER
\*------------------------------------*/
.menu-button {
	.btn-spinner-overlay {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background-color: rgba($black, 0.6);
		border-radius: $btn-border-radius;
		backdrop-filter: blur(2px);
		z-index: 5;
		cursor: wait;
	}
}
</style>
